import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import Vuerify from 'vuerify'
import VuerifyDirective from 'v-vuerify-next'
import VueI18n from 'vue-i18n'
import Vuex from 'vuex'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' // 简体中文

import '../static/login.css'
import store from './auth/store'
import routes from './routes'
import auth from './auth/auth'
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuerify, {
    icode: { test: /^\d{6}$/, message: '请输入6位数字' },
    mobile: { test: /\d{1,}/, message: 'Mobile must have 1 or more numbers' },
    realname: { test: /^[A-Za-z0-9][A-Za-z0-9\s]{2,18}[A-Za-z0-9]$/, message: '请输入正确姓名' },
    password: { test: /\S{6,20}/, message: '密码格式不对' },
    postcode: { test: /^\d{6}$/, message: '请输入6位数字' },
    height: { test: /^\d{2,}$/, message: 'Height must have 2 or more numbers' },
    weight: { test: /^\d{2,}$/, message: 'Weight must have 2 or more numbers' },
    email: { test: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: 'Please enter a valid Email.' },
});
Vue.use(VuerifyDirective);
Vue.use(VueI18n);
Vue.use(Vuex);

import { zhMessages } from './lang/zh.js'

const i18n = new VueI18n({
    // 写死为中文
    locale: 'zh',
    messages: {
        'zh': Object.assign(zhMessages, zhLocale)
    },
});
Vue.use(ElementUI, {
    // i18n: (key, value) => i18n.t(key, value)
});

const router = new VueRouter({
    //mode:'history',
    routes
});

Vue.prototype.pushRequest = function(request) {
    this.$store.commit('updateRequest', request);
};
Vue.http.interceptors.push((request, next) => {
    //console.log(this)//此处this为请求所在页面的Vue实例
    let MachID =localStorage.getItem('MachineCode')
    request.headers.set('Token', 'C0NNqtiOd2BWElrR8W4l8c2t5O1NaX0D2c7cgGfFAyYykYTtgh6KUJTwA8WBSBkd')
    request.headers.set('MachID', MachID)
    if (request.method === 'GET') {
        // request.url += '?_=' + new Date().getTime();
      if (request.url.indexOf('?')>0) {
        request.url +='&_='+new Date().getTime();
      } else {
        request.url +='?_='+new Date().getTime();
      }
    }
    next((response) => {
        const ERROR = response.data.error
        i18n.locale = store.getters.getLang
        // 对于error不是0的返回值进行处理
        if(ERROR){
          switch(ERROR){
            case 1061:
              router.push('/login')
              sessionStorage.setItem('1061Flag','true')
              break
          }
        }
        return response
        // clearTimeout(timeout);
    });
});

router.beforeEach((to, from, next) => {
  // const userType = sessionStorage.getItem('userType')
  let flag =auth.queryPathPargram()

  console.log(to.path)
  if (!sessionStorage.getItem('token')&&!flag) {
      if (to.path.match(/^\/login/g)) {
          next();
      } else {
          next({ path: '/login' });
      }
      // TODO:隔离不同用户，需要完善患者类型
  } else {
      next();
  }
});
// 拦截器定义应该放在实例前面，防止刷新页面后拦截器来不急起作用
let vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js